module.exports = __webpack_public_path__ + "static/media/creative.04116555.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/creative.svg
// module id = 543
// module chunks = 1